import { render, staticRenderFns } from "./BaseSpecialTable.vue?vue&type=template&id=f8ac8d12&scoped=true&"
import script from "./BaseSpecialTable.vue?vue&type=script&lang=js&"
export * from "./BaseSpecialTable.vue?vue&type=script&lang=js&"
import style0 from "./BaseSpecialTable.vue?vue&type=style&index=0&id=f8ac8d12&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8ac8d12",
  null
  
)

export default component.exports